import { useContext, useMemo } from 'react';
import { i18nUtils } from './utils';
import I18nContext from './context';

export const useTranslation = () => {
  const ctx = useContext(I18nContext);
  const api = useMemo(() => ({
    t: ctx.t,
    // tn: translate with count (pluralization helper)
    tn: (key, count, params, opts) => ctx.t(key, { ...(params || {}), count }, { ...(opts || {}), count }),
    // exists: check if a translation key is present
    exists: (key) => i18nUtils.validateKeyExists(ctx.translations, key),
    language: ctx.language,
    setLanguage: ctx.setLanguage,
    translations: ctx.translations,
  }), [ctx]);
  return api;
};

export default useTranslation;


